import React, { useRef, useState } from 'react'

import { DropDownOption } from '@store/types'

import { ChevronSvg, MapPinSvg } from '@svg/react'

import useOutsideClick from '@adUtilities/hooks/use-outside-click'

interface Props {
  activeZone: string
  zoneOptions: Array<DropDownOption>
  onChange: (arg: string) => void
}

export default function ZoneDropdown({
  activeZone,
  zoneOptions,
  onChange,
}: Props) {
  const [toggle, setToggle] = useState(false)

  const ref = useRef<HTMLDivElement>(null)

  useOutsideClick({
    ref,
    isOpen: toggle,
    onOutsideClick: () => setToggle(false),
  })

  return (
    <div className="relative inline-block text-left" ref={ref}>
      <button
        data-testid="toggle-filter"
        onClick={() => setToggle(!toggle)}
        type="button"
        className={`flex w-full items-center justify-between gap-2 bg-white p-2 px-4 text-black drop-shadow-40 ${
          toggle
            ? 'rounded-tl rounded-tr border-[#999]'
            : 'rounded border-white'
        } border-b`}
      >
        <div className="flex items-center gap-2">
          <MapPinSvg />
          <span>{activeZone || zoneOptions[0].value}</span>
        </div>
        <ChevronSvg
          className="h-6 w-6"
          stroke={2}
          rotate={toggle ? 'top' : 'down'}
        />
      </button>

      {toggle && (
        <div className="absolute left-0 z-10 w-full rounded-bl rounded-br border-t-0 border-[#999999] bg-white py-2 shadow-lg">
          {zoneOptions.map((item) => (
            <button
              key={item.value}
              className={`${
                activeZone === item.value ? 'text-mainColour' : ''
              } block w-full px-4 py-2 text-left text-black hover:bg-gray-100`}
              onClick={() => {
                setToggle(false)
                onChange(item.value)
              }}
              type="button"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
